import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class VehicleActivity extends SmartModel {
	constructor(data) {
		super();
		
        this.customData = {};
        this.deviceDate = "0000-00-00 00:00:00"
		this.geo = {};
		this.id = "";
		this.km = "";
		this.type = "";
        this.vehicleId = "";
        
        this.__vehicleName = "";

		if (data) {
			this.import(data);
		}
	}

	export (options) {
        var exportData = this.__export();

        console.log(this, exportData)
        
        exportData.customData = JSON.stringify(this.customData);
        exportData.deviceDate = moment().utc().format("YYYY-MM-DD HH:mm:ss");
        exportData.geo = JSON.stringify(this.geo);
        
        console.log(exportData)
		return exportData;
	}

	import (data, options) {
        this.__import(data);

        this.customData = Utils.parseJSON(data.customData);
        this.deviceDate = moment.utc(data.deviceDate).local();
        this.geo = Utils.parseJSON(data.geo);
    }

	onDataChanged(data){
        console.log(data);
		switch (data.property) {
			case "__vehicleName":
				const vehicleList = Shark.get("vehicleList");
				const vehicle = Utils.safp(vehicleList, "name", this.__vehicleName);
	
				const vehicleField = document.querySelector("#vehicleField");

				if (vehicleField) {
					if (!vehicle) {
						vehicleField.classList.add("is-invalid");
						vehicleField.classList.remove("is-valid");
					}
					else {
						this.vehicleId = vehicle.id;
						vehicleField.classList.add("is-valid");
						vehicleField.classList.remove("is-invalid");
					}
				}
				break;
        }
        
        console.log(this);
	}

};

Shark.registerModel("VehicleActivity", VehicleActivity);